import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
registerModuleCatalog('dynamic-rules', (locale) => import(`./locales/${locale}.po`), { eager: true });
export const loadDynamicRulesMessages = () => ensureModuleMessages('dynamic-rules');
